import React, { useState, useEffect } from "react";
import axios from "axios";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { getApiClient } from "../../libs/axiosInstance";
import { loadAuth } from "../../libs/authMgmt";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function WeeklySalesReport() {
  const [weeklyData, setWeeklyData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWeekly = async () => {
      try {
        const res = await getApiClient().get("/api/sales/weekly");
        //console.log(res.data);
        setWeeklyData(res.data);
      } catch (err) {
        console.error("Failed to fetch weekly sales:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchWeekly();
  }, []);

  const today = new Date();
  const start = new Date();
  start.setDate(today.getDate() - today.getDay()); // Sunday start
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const labels = days.map((d, idx) => {
    const current = new Date(start);
    current.setDate(start.getDate() + idx);
    return `${d} (${current.toLocaleDateString()})`;
  });

  const chartData = {
    labels,
    datasets: [
      {
        label: "Total Sales (" + loadAuth("company")?.currency + ")",
        data: labels.map((_, idx) => {
          const match = weeklyData.find((x) => x._id.day === idx + 1);
          return match ? match.totalAmount : 0;
        }),
        borderColor: "rgba(54,162,235,1)",
        tension: 0.3,
      },
    ],
  };

  return (
    <div
      className="sales_chart_cont"
      style={{
        backgroundColor: "transparent",
      }}
    >
      <h2>Sales Report (This Week)</h2>
      {weeklyData.length === 0 && !loading ? (
        <>
          <div className="alert alert-danger">Not enough data</div>
        </>
      ) : (
        <>
          {loading && <p>Loading weekly sales...</p>}
          {!loading && weeklyData.length > 0 && (
            <Line
              data={chartData}
              options={{
                responsive: true,
                plugins: { legend: { position: "top" } },
                scales: { y: { beginAtZero: true } },
              }}
            />
          )}
        </>
      )}
    </div>
  );
}
